import React from 'react'

const TransactionSuccess = () => {
  return (
    <div>TransactionSuccess</div>
  )
}

export default TransactionSuccess